import { garHouseInfoFieldsInSS, houseTypes } from '../FiasOverrider.constants';
export const convertGarHouseToSSHouse = (house) => {
    if (!house) {
        return;
    }
    const name = house?.name || house?.text || undefined;
    const garHouseInfo = house?.data;
    const parts = garHouseInfoFieldsInSS.reduce((acc, cur) => {
        const number = garHouseInfo?.[cur.numberFieldName];
        if (!number) {
            return acc;
        }
        const houseType = garHouseInfo[cur.typeFieldName];
        const type = houseTypes.find((item) => item.toLowerCase() === houseType?.toLowerCase());
        return [...acc, { type, number }];
    }, []);
    return {
        name,
        parts: parts.length ? parts : undefined,
        fiasId: garHouseInfo?.fiasId || undefined,
    };
};
